import { Component, Vue } from "vue-property-decorator";
import {
    ArgumentsModule,
    ChangeEventsModule,
    CommentsModule,
    DisplayModule,
    DocumentsModule, RouterModule,
    SectionsModule,
    UsersModule
} from '@/store/store.helper';
import { NAVBAR_COLOR, NAVBAR_SIDE_ICON, NavBarInterface } from "@/store/types";
import { EVENT_TYPE } from '@/types/enums';
import {ChangeEventInterface, SectionInterface} from "@/types/interfaces";
import deletePopup from "@/components/delete.popup/delete.popup.vue";
import {eventBus} from "@/main";
import * as enums from '@/types/enums';
import {user} from "firebase-functions/lib/providers/auth";
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);

@Component({
    components: {
        'delete-popup' : deletePopup
    }
})

export default class EventActivity extends Vue {

    @DisplayModule.DisplayGetter private dateFormatted;
    @DisplayModule.DisplayGetter private getColor;
    @DisplayModule.DisplayMutation private setNavBar;
    @DisplayModule.DisplayGetter private showDeleteButton;

    @UsersModule.UsersGetter private participantDisplayNameById;
    @UsersModule.UsersGetter private participantPhotoUrlById;
    @UsersModule.UsersGetter private userUid;
    @UsersModule.UsersGetter private isSignedIn;
    @UsersModule.UsersAction private validateUserAccessToDocument;

    @SectionsModule.SectionsGetter private sectionById;
    @ArgumentsModule.ArgumentsGetter private argumentById;
    @CommentsModule.CommentsGetter private commentById;
    @ChangeEventsModule.ChangeEventsGetter private changeEvents;

    @DocumentsModule.DocumentsGetter private documentHideCounter;
    @DocumentsModule.DocumentsGetter private documentHideVoteEvents;

    @RouterModule.RouterGetter private getPath;
    @RouterModule.RouterAction private push;
    private items = [
        { label: 'eventNotification.createdAt', value: 'createdAt' },
        { label: 'eventNotification.myEvents', value: 'myEvents' },
        { label: 'eventNotification.byEventType', value: 'byEventType' }
    ];

    private selectedFilter = 'createdAt';
    private events: Array<ChangeEventInterface> = [];
    private dialog = false;
    private itemDeleteId: string = '';
    private readMore = {};
    private mounted() {
        let events = <Array<ChangeEventInterface>>Object.values(this.changeEvents);
        this.events = events
        .sort((eventA: ChangeEventInterface, eventB: ChangeEventInterface) => new Date(eventB.createdAt).getTime() - new Date(eventA.createdAt).getTime());
        this.events = this.events.slice(0, 50)
        window.addEventListener('scroll', this.mountFeed)
    }

    mountFeed() {
        const navBarPref: NavBarInterface = {
            title: '',
            icon: NAVBAR_SIDE_ICON.menu,
            color: this.getColor(enums.SECTION_STATUS.inTheVote),
        };
        this.setNavBar(navBarPref);
        this.getEvents(this.selectedFilter);
        for (let i = 0; i < Object.keys(this.changeEvents).length; i++) {
            this.readMore[Object.keys(this.changeEvents)[i]] =
                (this.notificationText(this.changeEvents[Object.keys(this.changeEvents)[i]]).length > 120)
        }
        eventBus.$on('mountVoteFeed', () => {
            this.mountFeed();
        });
    }

    private showMore(id) {
        this.readMore[id] = false;
        this.$forceUpdate();
    }

    private getEvents(sort) {
        window.removeEventListener('scroll', this.mountFeed);

        let events = <Array<ChangeEventInterface>>Object.values(this.changeEvents);

        // See https://github.com/wonderfloyd/Consenz/tree/master/documentation/RestrictedDocument#voting_events_can_be_hidden_from_activity_page_topic
        // if the hideVoteEvents property exists in the document and is true, the elements of the voting event are not displayed 
        if (!!this.documentHideVoteEvents) {
            events = events.filter(event => event.type !== EVENT_TYPE.votedSuggestion);
        }
        if (this.documentHideCounter) {
            events = events.filter(event => event.type !== EVENT_TYPE.votedSuggestion);
        }
        if (sort === 'createdAt') {
            this.events = events
                .sort((eventA: ChangeEventInterface, eventB: ChangeEventInterface) => new Date(eventB.createdAt).getTime() - new Date(eventA.createdAt).getTime());
        } else if (sort === 'byEventType') {
            const order = ['editedSuggestion', 'acceptedNewSuggestion', 'acceptedEditSuggestion', 'addedNewSuggestion', 'addedEditSuggestion', 'addedArgument', 'addedComment', 'votedSuggestion'];
            this.events = events.sort((eventA: ChangeEventInterface, eventB: ChangeEventInterface) =>
                order.indexOf(<string>Object.keys(EVENT_TYPE).find(key => EVENT_TYPE[key] === eventA.type))
                - order.indexOf(<string>Object.keys(EVENT_TYPE).find(key => EVENT_TYPE[key] === eventB.type))
            );
        } else {
            this.events = events
                .sort((eventA: ChangeEventInterface, eventB: ChangeEventInterface) => {
                    if (this.isSignedIn) {
                        return eventA.creator === this.userUid ? -1 : 1;
                    } else {
                        return eventA.creator.localeCompare(eventB.creator) ? 1 : -1;
                    }
                });
        }
    }

    private beforeDestroy() {
        eventBus.$off('mountVoteFeed');
    }
    private onClickBack() {
        history.go(-1);
    }

    private notificationText(event) {
        let notificationText;
        try {
            switch (event.type) {
                case EVENT_TYPE.votedSuggestion:
                    notificationText = this.$t('eventNotification.votedSuggestion', {eventType: this.$t(event.subType), reactingUserName: this.participantDisplayNameById(event.creator),
                        suggestionTextPrefix: this.sectionById(event.itemId)[0].content, userName: this.sectionById(event.itemId)[0] ? this.participantDisplayNameById(this.sectionById(event.itemId)[0].owner) : ''});
                    break;
                case EVENT_TYPE.addedArgument:
                    notificationText = this.$t('eventNotification.addedArgument', {reactingUserName: this.participantDisplayNameById(event.creator),
                        argumentTextPrefix: this.argumentById(event.itemId).content, userName: this.sectionById(this.argumentById(event.itemId).sectionId)[0] ? this.participantDisplayNameById(this.sectionById(this.argumentById(event.itemId).sectionId)[0].owner) : ''});
                    break;
                case EVENT_TYPE.addedComment:
                    let userName;
                    if (event.subType === 'Section') {
                        userName = this.sectionById(this.commentById(event.itemId).sectionId)[0] ? this.participantDisplayNameById(this.sectionById(event.itemId)[0].owner) : '';
                    } else {
                        userName = this.argumentById(this.commentById(event.itemId).argumentId) ? this.participantDisplayNameById(this.argumentById(this.commentById(event.itemId).argumentId).owner) : '';
                    }
                    notificationText = this.$t('eventNotification.addedComment', {item: this.$t(event.subType.toLowerCase()), reactingUserName: this.participantDisplayNameById(event.creator),
                        commentTextPrefix: this.commentById(event.itemId).content, userName});
                    break;
                case EVENT_TYPE.addedNewSuggestion:
                    notificationText = this.$t('eventNotification.addedNewSuggestion', {topic: this.sectionById(event.itemId)[0].topic, reactingUserName: this.participantDisplayNameById(event.creator),
                        sectionTextPrefix: this.sectionById(event.itemId)[0].content});
                    break;
                case EVENT_TYPE.addedEditSuggestion:
                    notificationText = this.$t('eventNotification.addedEditSuggestion', {topic: this.sectionById(event.itemId)[0].topic, reactingUserName: this.participantDisplayNameById(event.creator),
                        sectionTextPrefix: this.sectionById(event.itemId)[0].content});
                    break;
                case EVENT_TYPE.acceptedNewSuggestion:
                    notificationText = this.$t('eventNotification.acceptedNewSuggestion', {userName: this.participantDisplayNameById(event.creator),
                        suggestionTextPrefix: this.sectionById(event.itemId)[0].content});
                    break;
                case EVENT_TYPE.acceptedEditSuggestion:
                    notificationText = this.$t('eventNotification.acceptedEditSuggestion', {userName: this.participantDisplayNameById(event.creator),
                        suggestionTextPrefix: this.sectionById(event.itemId)[0].content});
                    break;
                case EVENT_TYPE.editedSuggestion:
                    notificationText = this.$t('eventNotification.editedSuggestion', {userName: this.participantDisplayNameById(event.creator),
                        originalText: this.sectionById(this.sectionById(event.itemId)[0].parentSectionId)[0].content, newText: this.sectionById(event.itemId)[0].content});
                    break;
                default:
                    notificationText = '';
            }
        } catch (e) {
            notificationText = '';
        }
        return notificationText;
    }


    private showDialog(itemId) {
        this.dialog = true;
        this.itemDeleteId = itemId;
    }

    private truncatedText(text) {
        return (text.length > 120) ? text.substr(0, 119) + '...' : text;
    }

    private goToItem(event) {
        let sectionId;
        let object;
        if (event.type === EVENT_TYPE.addedArgument) {
            sectionId = this.argumentById(event.itemId).sectionId;
            object = 'argument';
        } else if (event.type === EVENT_TYPE.addedComment) {
            sectionId = this.commentById(event.itemId).sectionId;
            object = 'comment';
        } else {
            sectionId = event.itemId;
            object = 'section';
        }
        const path = this.getPath({
            name: enums.ROUTE_NAME.section,
            params: {
                [enums.SECTION_BY.sectionById]: sectionId,
            },
        });
        this.push({path});
        if (event.type === EVENT_TYPE.addedArgument || event.type === EVENT_TYPE.addedComment) {
            setTimeout(() => {
                eventBus.$emit('scrollTo', {scrollTo: object, scrollId: event.itemId});
            }, 1000);
        }
    }

    private goToChoose(): void {
        this.$router.push({name: enums.ROUTE_NAME.chooseTopics})
    }

    // Used to validate access to the document. Called before the route rendered by this component is confirmed.
    public beforeRouteEnter (to, from, next) {
        next(async vm => {
            const authorized = await vm.validateUserAccessToDocument()
            authorized || next(from)
        });
    }
}
